module.exports = __webpack_public_path__ + "static/media/img3-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/P/img3-1.png
// module id = 1246
// module chunks = 3